<template>
  <div class="user-cdds app__block">
    <div class="app-list">
      <template v-if="isLoaded && verificationsList.length && !isFailed">
        <template v-if="pendingVerifications.length">
          <h3
            class="user-cdds__list-title">
            {{ 'user-cdds.active-cdds' | globalize }}
          </h3>
          <div class="app-list__header">
            <span class="app-list__cell app-list__cell--left">
              {{ "user-cdds.lbl-id" | globalize }}
            </span>
            <span class="app-list__cell app-list__cell--center">
              {{ "user-cdds.lbl-user-id" | globalize }}
            </span>
            <span class="app-list__cell app-list__cell--right">
              {{ "user-cdds.lbl-verify-status" | globalize }}
            </span>
            <span class="app-list__cell app-list__cell--right">
              {{ "verifications-list.lbl-created" | globalize }}
            </span>
          </div>
          <button
            class="app-list__li"
            v-ripple
            v-for="item in pendingVerifications"
            :key="`user-cdds-${item.id}`"
            @click="redirectToVerificationDetails(item.id)"
          >
            <span
              class="app-list__cell app-list__cell--left"
              :title="item.id"
            >
              {{ item.id }}
            </span>

            <span
              class="app-list__cell app-list__cell--center"
              :title="item.userId"
            >
              {{ item.userId }}
            </span>

            <span
              class="app-list__cell app-list__cell--right"
              :title="item.status"
            >
              {{ item.status }}
            </span>
            <span
              class="app-list__cell app-list__cell--right"
              :title="item.createdAt"
            >
              {{ item.createdAt | formatDateDMYT }}
            </span>
          </button>
        </template>

        <template v-if="otherVerifications.length">
          <h3
            v-if="otherVerifications.length"
            class="user-cdds__list-title">
            {{ 'user-cdds.completed-cdds' | globalize }}
          </h3>
          <div class="app-list__header">
            <span class="app-list__cell app-list__cell--left">
              {{ "user-cdds.lbl-id" | globalize }}
            </span>
            <span class="app-list__cell app-list__cell--center">
              {{ "user-cdds.lbl-user-id" | globalize }}
            </span>
            <span class="app-list__cell app-list__cell--right">
              {{ "user-cdds.lbl-verify-status" | globalize }}
            </span>
            <span class="app-list__cell app-list__cell--right">
              {{ "verifications-list.lbl-created" | globalize }}
            </span>
          </div>
          <button
            class="app-list__li"
            v-ripple
            v-for="item in otherVerifications"
            :key="`user-cdds-${item.id}`"
            @click="redirectToVerificationDetails(item.id)"
          >
            <span
              class="app-list__cell app-list__cell--left"
              :title="item.id"
            >
              {{ item.id }}
            </span>

            <span
              class="app-list__cell app-list__cell--center"
              :title="item.userId"
            >
              {{ item.userId }}
            </span>

            <span
              class="app-list__cell app-list__cell--right"
              :title="item.status"
            >
              {{ item.status }}
            </span>
            <span
              class="app-list__cell app-list__cell--right"
              :title="item.createdAt"
            >
              {{ item.createdAt | formatDateDMYT }}
            </span>
          </button>
        </template>
      </template>

      <template v-else>
        <div class="app-list__li-like">
          <template v-if="isLoaded && !verificationsList.length">
            <p>
              {{ "user-cdds.nothing-here-yet" | globalize }}
            </p>
          </template>

          <template v-else-if="isFailed">
            <p>
              {{ "user-cdds.default-error-message" | globalize }}
            </p>
          </template>

          <template v-else>
            <p>
              {{ "user-cdds.loading-message" | globalize }}
            </p>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { ErrorHandler } from '@/js/helpers/error-handler'
import { clearObject } from '@/js/helpers/clear-object'
import { api } from '@/api'
import { vueRoutes } from '@/vue-router/routes'
import { VerificationRecord } from '@/js/records/entities/verification.record'

export default {
  name: 'user-cdds',
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data () {
    return {
      isLoaded: false,
      isFailed: false,
      isPending: false,
      verificationsList: [],
      pendingVerifications: [],
      otherVerifications: [],
    }
  },

  async created () {
    await this.getVerifications()
    this.filterVerifications()
  },
  methods: {
    async getVerifications () {
      this.isLoaded = false
      this.isFailed = false
      let response = {}
      try {
        const query = {
          filter: clearObject({
            user_id: this.id,
            type: 'manual',
          }),
        }
        if (this.$route.name === vueRoutes.userBDDs.name) {
          query.filter.type = 'kyb'
        }
        const { data } = await api.getWithSignature('/verifications', query)
        this.verificationsList = data.map(i => new VerificationRecord(i))
      } catch (e) {
        ErrorHandler.processWithoutFeedback(e)
        this.isFailed = true
      }

      this.isLoaded = true
      return response
    },

    filterVerifications () {
      this.pendingVerifications = this.verificationsList.filter(item => item.status === 'pending_manual')
      this.otherVerifications = this.verificationsList.filter(item => item.status !== 'pending_manual')
    },

    redirectToVerificationDetails (id) {
      this.$router.push({
        name: vueRoutes.verificationDetails.name,
        params: { id },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.user-cdds__list-title {
  margin: 1rem 0 2rem 2rem;
}
</style>
